import React from "react";
import Link from "gatsby-link";
import FullLogoOnWhite from "./full-logo-on-white.svg";
import StripeCheckout from "react-stripe-checkout";
import { withPrefix } from "gatsby-link";

export default () => {
  return (
    <div className="container">
      <header>
        <h1>Quiver speed comparison</h1>
      </header>
      <iframe
        src="https://speed.graphql-quiver.com/"
        frameborder="0"
        id="benchmarks-iframe"
        data-form-source="https://speed.graphql-quiver.com/"
        className="iframe-form "
        data-pass-through-params="code next platform trial plan period referrer"
      />
      <style jsx>{`
        #benchmarks-iframe {
          border: none;
          width: 100%;
          height: 900px;
        }
      `}</style>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/benchmarks.js